import * as Yup from 'yup';

export const defaultTaskValidator = Yup.object().shape({
    responsible: Yup.string().required('Please provide the responsible field'),
    name: Yup.string().required('The task name is required'),
    deadline: Yup.string().required('Please provide the task deadline')
  });